import React, { Component } from "react";
import Inputmask from 'inputmask';

import LabelForm from "../../../components/LabelForm";
import InputMaskForm from "../../../components/InputMaskForm";
import InputHour from "../../../components/InputHour";
import SelectForm from "../../../components/SelectForm";
import InputForm from "../../../components/InputForm";
import { apheresisKits, equipmentsActives, lookupsOrderBy, medicalStaffOption } from "../../../libs/services";

class Apheresis extends Component{
    constructor(props){
        super(props);
        
        this.getApheresisKits = this.getApheresisKits.bind(this);

        this.state = {
            staffList:[],
            equipments:[],
            arms:[],
            tubes:[{value:'0',text:'Si'}, {value:'1', text:'No'}],
            bag_flags:[{value:'1',text:'Si'}, {value:'0', text:'No'}],
            criopreserves:[{value:true,text:'Si'}, {value:false, text:'No'}],
            pickings:[{value:'TOTAL',text:'Total'}, {value:'REDUCIDA', text:'Reducida'}],
            apheresis:[],
            componentsKit:[]
        }
    }
    
    async componentDidMount(){
        this.props.onRef(this);

        var selector = document.getElementById("start_hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

		var selector = document.getElementById("end_hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

        var options = [];
        var response = await medicalStaffOption('mainInfo');
        if(response){
            options = [];
            response.forEach(res => {
                options.push({
                    value:res.medical_staff.id,
                    text:' '+res.medical_staff.names+' '+
                            (res.medical_staff.lastname1 ? res.medical_staff.lastname1+' ' : "")+
                            (res.medical_staff.lastname2 ? res.medical_staff.lastname2 : "")
                });
            });

            this.setState({staffList:options});
        }

        response = await equipmentsActives('SEPARADOR_CELULAR');
		if(response){
            options = [];
            response.forEach(res => {
                options.push({
                    value:res.equipment.id,
                    text:res.equipment.name
                });
            });
			this.setState({equipments: options});
		}

        response = await lookupsOrderBy('arm_type');
        if(response){
            options = [];
            response.forEach(res => {
                options.push({
                    value:res.key,
                    text:res.name
                });
            });

            this.setState({arms:options});
            
        }
    }

    componentWillUnmount(){
        this.props.onRef(null);
    }

    async getApheresisKits(et_id){
        var response = await apheresisKits(et_id);
        if(response){
            var options = [];
            response.forEach(res => {
                options.push({
                    id:res.apheresis_kit.id,
                    value:res.apheresis_kit.id,
                    text:res.apheresis_kit.name,
                    asigned_components:res.asigned_components
                });
            });

            this.setState({apheresis:options});
        }
    }

    render(){
        const {t} = this.props;

        return(
            <>
                <fieldset>
                    <legend>Datos Extracción</legend>
                    <div className="col-xs-12 no-padding" style={{marginTop:8}}>                        
                        <div className="col-xs-12 col-sm-4 no-padding">
                            <div className="col-xs-12">
                                <LabelForm text={t('content.extractions.form.date_extraction')} />
                                {this.props.error_date !== "" &&
                                    <LabelForm 
                                        text={this.props.error_date} 
                                        styles={{marginLeft:8, fontSize:11, color:'red', display:(this.props.error_date.length > 15 ? 'block' : 'unser')}} 
                                    />
                                }
                                {this.props.error_hour !== "" &&
                                    <LabelForm 
                                        text={this.props.error_hour} 
                                        styles={{marginLeft:8, fontSize:11, color:'red', display:(this.props.error_hour.length > 15 ? 'block' : 'unser')}} 
                                    />
                                }
                            </div>
                            
                            <div className="col-xs-12 col-sm-6">
                                <InputMaskForm 
                                    id="date"
                                    value={this.props.extraction.date}
                                    handleChange={this.props.handleChange}
                                    disabled={this.props.disabled}
                                    variables={{type:'obj', name:'extraction'}}
                                    class={this.props.error_date !== '' ? ' error' : ''}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-6">
                                <InputHour 
                                    id="hour"
                                    value={this.props.extraction.hour}
                                    disabled={this.props.disabled}
                                    handleChange={this.props.handleChange}
                                    variables={{type:'obj', name:'extraction'}}
                                    class={this.props.error_hour !== '' ? ' error' : ''}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-6" style={{paddingRight:0}}>
                            <LabelForm text={t('content.extractions.form.medical_staff')} />
                            <SelectForm 
                                id="medical_staff_id"
                                value={this.props.extraction.medical_staff_id}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                options={this.state.staffList}
                                required
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-1">
                            <LabelForm text={t('content.extractions.form.start_hour')} />
                            <InputHour 
                                id="start_hour"
                                value={this.props.extraction.start_hour}
                                disabled={this.props.disabled}
                                handleChange={this.props.handleChange}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-1">
                            <LabelForm text={t('content.extractions.form.end_hour')} />
                            <InputHour 
                                id="end_hour"
                                value={this.props.extraction.end_hour}
                                disabled={this.props.disabled}
                                handleChange={this.props.handleChange}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                    </div>
                    <div className="col-xs-12 no-padding">                        
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.form.arm')} />
                            <SelectForm 
                                id="arm"
                                value={this.props.extraction.arm}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                options={this.state.arms}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.form.tube')} />
                            <SelectForm 
                                id="tube"
                                value={this.props.extraction.tube}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                options={this.state.tubes}
                                required
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.st.bag')} />
                            <SelectForm 
                                id="bag_flag"
                                value={this.props.extraction.bag_flag}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                options={this.state.bag_flags}
                                required
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.form.equipment')} />
                            <SelectForm 
                                id="equipment_id"
                                value={this.props.extraction.equipment_id}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                options={this.state.equipments}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.apheresis.lote_number')} />
                            <InputForm 
                                id="lote_number"
                                value={this.props.extraction.lote_number}
                                handleChange={this.props.handleChange}
                                maxLength="45"
                                required
                                disabled={this.props.disabled}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        {this.props.extraction.type !== 'AF' &&
                            <div className="col-xs-12 col-sm-2">
                                <LabelForm text="Criopreservadas" />
                                <SelectForm 
                                    id="crio_preserved"
                                    value={this.props.extraction.crio_preserved}
                                    handleChange={this.props.handleChange}
                                    disabled={this.props.disabled}
                                    options={this.state.criopreserves}
                                    variables={{type:'obj', name:'extraction'}}
                                />
                            </div>
                        }
                    </div>
                    <div className="col-xs-12 no-padding">
                        <div className="col-xs-12  col-sm-2">
                            <LabelForm text={t('content.extractions.apheresis.lote_anticuagulant')} />
                            <InputForm                                 
                                id="lote_anticuagulant"
                                value={this.props.extraction.lote_anticuagulant}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                maxLength="45"
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>

                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.apheresis.volume_anticoagulant')} />
                            <InputForm 
                                type="number"
                                id="volume_anticoagulant"
                                value={this.props.extraction.volume_anticoagulant}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.apheresis.cycle_number')} />
                            <InputForm 
                                type="number"
                                id="cycle_number"
                                value={this.props.extraction.cycle_number}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-2">
                            <LabelForm text={t('content.extractions.apheresis.processed_blood')} />
                            <InputForm 
                                id="processed_blood"
                                value={this.props.extraction.processed_blood}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        {this.props.extraction.type !== 'AF' &&
                            <div className="col-xs-12 col-sm-2">
                                <LabelForm text="Cosecha" />
                                <SelectForm 
                                    id="picking"
                                    value={this.props.extraction.picking}
                                    handleChange={this.props.handleChange}
                                    disabled={this.props.disabled}
                                    options={this.state.pickings}
                                    variables={{type:'obj', name:'extraction'}}
                                />
                            </div>
                        }
                    </div>
                    <div className="col-xs-12 no-padding form-group">
                        <div className="col-xs-12 col-sm-4">
                            <LabelForm text={t('content.extractions.apheresis.apheresis_kits_id')} />
                            <SelectForm 
                                id="apheresis_kits_id"
                                value={this.props.extraction.apheresis_kits_id}
                                handleChange={this.props.handleChange}
                                disabled={this.props.disabled}
                                required
                                options={this.state.apheresis}
                                variables={{type:'obj', name:'extraction'}}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-2" style={{marginTop:"20px"}}>
                            <input 
                                type="checkbox" 
                                name="doubleUnits" 
                                id="doubleUnits" 
                                value={this.props.doubleUnits } 
                                disabled={this.props.disabled}
                                checked={this.props.doubleUnits}
                                onChange={(e)=>this.props.handleChange(e)}
                            /> <LabelForm text="Doble" />
                        </div>
                    </div>
                    {this.props.units.length > 0 &&
                        <div className="col-xs-12 no-padding">
                            <div className="col-sm-6">
                                <div className="col-xs-12 col-sm-3 col-sm-offset-6 center">
                                    <LabelForm text="Bolsa 1" />
                                </div>
                                {this.props.doubleUnits &&
                                    <div className="col-xs-12 col-sm-3 center">
                                        <LabelForm text="Bolsa 2" />						    		
                                    </div>
                                }
                                    
                            </div>
                        </div>
                    }
                    <div className="col-xs-12 no-padding">
                        <div className="col-xs-12 col-sm-6">
                            {this.props.units.map((unit, i)=>
                                <div key={i}>
                                    <div className="col-xs-12 col-sm-6">
                                        <LabelForm text={unit.component_name} />
                                    </div>
                                    {unit.units.map((item, j)=>
                                        item.show &&
                                            <div className="col-xs-12 col-sm-3" key={j}>
                                                <div className="cil-xs-12 no-padding">                                            
                                                    <InputForm
                                                        type="number"
                                                        id={"volume_"+i}
                                                        value={item.volume}
                                                        handleChange={this.props.updateUnitsAF}
                                                        variables={{name:'volume', index:i, unit:j}}
                                                        disabled={this.props.disabled}
                                                        maxLength={4}
                                                        required
                                                    />
                                                </div>
                                                {!unit.flag &&
                                                    <>
                                                        <div className="col-xs-12 no-padding">
                                                            <LabelForm text="Rendimiento P." />
                                                            <InputForm
                                                                id={"rendimiento_"+i}
                                                                value={item.rendimiento}
                                                                handleChange={this.props.updateUnitsAF}
                                                                variables={{name:'rendimiento', index:i, unit:j}}
                                                                maxLength={50}
                                                                disabled={this.props.disabled}
                                                            />
                                                        </div>
                                                        <div className="col-xs-12 no-padding">
                                                            <LabelForm text="U. Equivalente" />
                                                            <InputForm
                                                                type="number"
                                                                id={"equivalente_"+i}
                                                                value={item.equivalente}
                                                                handleChange={this.props.updateUnitsAF}
                                                                variables={{name:'equivalente', index:i, unit:j}}
                                                                maxLength={1}
                                                                disabled={this.props.disabled}
                                                            />
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                    )}
                                    
                                </div>
                            )}
                        </div>
                    </div>
                </fieldset>
            </>
        )
    }
    
}

export default Apheresis;